jQuery(document).ready(function ($) {

    // Toggle Mobile Menu
    $(document).on('click', '.mobile-menu-toggle, .header-menu-toggle', function () {

        if ($('body').hasClass('menu-open')) {

            $('body').removeClass('menu-open');

        } else {

            $('body').addClass('menu-open');

        }

    });


    // Toggle Sub Menu
    $(document).on('click', '.header-navigation .toggle, .mobile-navigation .toggle', function () {

        var windowWidth = $(window).outerWidth();
        var element = $(this);
        var offset_right = windowWidth - element.offset().left + element.width();
        var sub_menu = $(this).siblings('ul');
        var sibling_sub_menus = $(this).parent().siblings().find('ul');
        var toggles = $(this).parent().children('.toggle');
        var sibling_toggles = $(this).parent().siblings().find('.toggle');

        if ($(this).hasClass('active')) {

            toggles.removeClass('active');

            if ($(this).closest('ul').hasClass('sub-menu')) {

                sub_menu.slideUp(200);

            } else {

                if (windowWidth > 767) {

                    sub_menu.hide();

                } else {

                    sub_menu.slideUp(200);

                }

            }

        } else {

            if (windowWidth > 767) {

                sibling_sub_menus.hide();
                sibling_toggles.removeClass('active');

            }

            toggles.addClass('active');

            if ($(this).closest('ul').hasClass('sub-menu')) {

                sub_menu.slideDown(200);

            } else {

                if (windowWidth > 767) {

                    sub_menu.fadeIn(200);

                } else {

                    sub_menu.slideDown(200);

                }

            }

            if (offset_right <= 300) {

                if (windowWidth > 767) {

                    sub_menu.addClass('align-right');

                }

            }
        }

    });

});

jQuery(document).ready(function ($) {


    $('.header-navigation-wrp').on('click', function (e) {
        if (e.target !== this)
            return;

        $('body').removeClass('menu-open');
    });

});